import{ClientResponse}from'./ClientResponse';export class VoidClientResponse extends ClientResponse{constructor(statusCode){super(undefined,statusCode);}}